import { CharacteristicsObject } from '../characteristics.model';

export abstract class CharacteristicObject {
    public mode: string;

    constructor(public name: string, public id: string) {
        this.mode = 'DEFAULT';
    }

    public abstract get value(): string | string[];
    public abstract set value(value: string | string[]);
    public abstract clone(): CharacteristicObject;
    public abstract equals(other: CharacteristicObject): boolean;

}
